var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useMemo } from 'react';
import { buildURI, useFetch } from '@hn-front/utils';
import { SKILLS_API } from '../constants/routes';
import { processSkillName } from '../utils/processSkillName';
import { escapeSpecialSymbols } from '../../../../components/Common/utils';
export var useGroupSkills = function (_a) {
    var groupId = _a.groupId, domainId = _a.domainId, schoolId = _a.schoolId;
    var _b = useFetch(buildURI(SKILLS_API.groupSkills, {
        pathParams: { groupId: groupId },
        filterQuery: {
            domainId: Array.isArray(domainId) ? domainId.join(', ') : domainId,
        },
        query: { schoolId: schoolId },
    }), { isCache: false }), data = _b.response, rest = __rest(_b, ["response"]);
    var groupSkills = useMemo(function () {
        if (!data)
            return data;
        return __assign(__assign({}, data), { grades: data.grades
                .filter(function (el) { return el.skills.length > 0; })
                .map(function (el) { return (__assign(__assign({}, el), { skills: el.skills.map(processSkillName) })); }), students: data.students.map(function (student) { return (__assign(__assign({}, student), { name: escapeSpecialSymbols(student.name) })); }) });
    }, [data]);
    return __assign(__assign({}, rest), { data: groupSkills });
};
